import { universalRouterProps } from 'core/universalRouter/types';
import { fetchSalesPromotions } from 'store/salesPromotion/actions';

export default ({ store: { dispatch } }: universalRouterProps, query: { [key: string]: string }) =>
  dispatch(fetchSalesPromotions({ ...query, limit: 30, offset: 0 }));
